import { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import { Button } from "@material-tailwind/react";

import { useConversationContext } from "../../contexts/ConversationContextProvider.js";
import { convertUnixTimestampToDateTime } from "../utils/timeStampConversion.js";

const WaFlowsSubmissions = () => {
  const { getWaFlowsSubmissions } = useConversationContext();
  const [waFlowsDataArray, setWaFlowsDataArray] = useState([]);

  const columns = [
    {
      field: "submissionTime",
      headerName: "Submission Time",
      width: 200,
    },
    {
      field: "from",
      headerName: "From",
      width: 150,
    },
    {
      field: "templateName",
      headerName: "WA Template Name",
      width: 200,
    },
    {
      field: "flowData",
      headerName: "Flows Response",
      width: 400,
      renderCell: (params) => {
        try {
          const jsonData =
            typeof params.value === "string"
              ? JSON.parse(params.value)
              : params.value;

          return (
            <div className="bg-black px-3 py-2 rounded-md text-sm text-white whitespace-pre-line">
              {Object.entries(jsonData || {}).map(([key, value]) => (
                <div key={key}>
                  {key} : {value}
                </div>
              ))}
            </div>
          );
        } catch (error) {
          return (
            <span className="bg-black px-3 py-2 rounded-md text-sm text-white">
              {params.value}
            </span>
          );
        }
      },
    },
  ];

  const handleWaFlowsSubmissions = async () => {
    const response = await getWaFlowsSubmissions();

    if (response?.Error) {
      toast.error(response?.Error);
    } else {
      setWaFlowsDataArray(response);
    }
  };

  const exportWaFlowsSubmission = () => {
    const flattenedData = waFlowsDataArray.map((row) => ({
      "Message from": row?.from || "",
      "Submission Time":
        (row?.timestamp && convertUnixTimestampToDateTime(row?.timestamp)) ||
        "",
      "Template Name": row?.templateName || "",
      "Flow Data": row?.flowData || "",
    }));

    const worksheet = XLSX.utils.json_to_sheet(flattenedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "WaFlowsSubmission");
    XLSX.writeFile(workbook, "WA_Flows_Submission.xlsx");
  };

  useEffect(() => {
    handleWaFlowsSubmissions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Transform data and add unique id to each row (DataGrid requires it)
  const dataRows =
    waFlowsDataArray?.map((row, index) => ({
      ...row,
      id: row.id || index,
      submissionTime:
        row?.timestamp && convertUnixTimestampToDateTime(row?.timestamp),
      templateName: row?.templateName || "-",
    })) || [];

  return (
    <main className="w-full mt-5 mb-10 lg:my-1 space-y-5">
      <div className="w-full space-y-2">
        <h1 className="text-2xl">WA Flows Submissions</h1>
        <h3>
          View all your WhatsApp Flows or WhatsApp Form submissions data here.
        </h3>
      </div>

      <div className="wbm-card-3 border-b-0 space-y-5">
        <Button
          color="blue"
          size="sm"
          disabled={waFlowsDataArray?.length < 1}
          onClick={exportWaFlowsSubmission}
        >
          Export to Excel
        </Button>
        <div style={{ height: 600, width: "100%" }}>
          <DataGrid
            rows={dataRows}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[5, 10, 25]}
            disableSelectionOnClick
            getRowHeight={() => "auto"}
          />
        </div>
      </div>
    </main>
  );
};

export default WaFlowsSubmissions;
